import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../utils/OggettiUtili";
import TabelleMonitoraggio from "./TabelleMonitoraggio";
import {states} from '../Wizard/States/States';
import SegnalazioniServices from "../../services/SegnalazioniServices";
import history from "../../utils/History";
import Utils from "../../utils/Utils";
class SegnalazioniDaLIS extends Component {

    state = {
   
           malattie: JSON.parse(sessionStorage.getItem("malattie")),
           filtriSegnalazione: {
               malattia: "",
               utenteInserimento: "",
               gruppoStatoSegnalazione: "",
               statoSchedaSpeciale: "",
               dataDa: "",
               dataA: "",
               segnalazioniLIS:"",
               statoInvio: "",
               lis:true,
               segnalazioniDaLis:true
           },
   
       }
   
       rowsFiltri = [
           {
               malattia: {
                   id: "malattia",
                   text: "malattia",
                   tipo: "autocomplete",
                   field: "malattia",
                   numeroCol: 1,
                   suggestions: this.state.malattie,
                   keyField: "codice",
                   descriptionField: "codDesc",
                   suggestionField: "descrizione"
               },
               gruppoStatoSegnalazione: {
                   id: "gruppoStatoSegnalazione", text: "", tipo: "select", field: "gruppoStatoSegnalazione", numeroCol: 2,
                   suggestions: OggettiUtili.statoSchedaStandardLIS, defaultSelect: "--Scheda Standard--"
               },
               dataDa: {
                   id: "dataDa",
                   text: "dataDa",
                   tipo: "data",
                   field: "dataDa",
                   placeholder: "data segnalazione da",
                   numeroCol: 3
               }
           },
           {
               utenteInserimento: {
                   id: "utenteInserimento",
                   text: "Utente inserimento",
                   tipo: "input",
                   field: "utenteInserimento",
                   numeroCol: 1
               },
               statoSchedaSpeciale: {
                   id: "statoSchedaSpeciale", text: "", tipo: "select", field: "statoSchedaSpeciale", numeroCol: 2,
                   suggestions: OggettiUtili.statoSchedaSpeciale, defaultSelect: "--Scheda Speciale--"
               },
               dataA: {
                   id: "dataA",
                   text: "dataA",
                   tipo: "data",
                   field: "dataA",
                   placeholder: "data segnalazione a",
                   numeroCol: 3
               }
            },
           {
             segnalazioniLIS: {
                   id: "segnalazioniLIS", text: "", tipo: "select", field: "segnalazioniLIS", numeroCol: 2,
                   suggestions: OggettiUtili.statoSegnalazioniLIS, defaultSelect: "--Segnalazioni LIS--"
               }
           }
        
   
       ]
   
      colsTabMonitoraggio = [
           {
               key: "malattia", name: "Malattia", sortDirection: "none", tipo: "dizionario",
               oggetto: JSON.parse(sessionStorage.getItem("malattiePerCodice")), campo: "descrizione"
           },
           {
               key: "idSegnalazione",
               name: "ID Segnalazione",
               sortDirection: "none",
               tipo: "link",
               path: "/wizardSegnalazione",
               nomeParametro: "idSegnalazione",
               state: {currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI}
           },
           {key: "ulssSegnalazione", name: "ULSS di segnalazione", sortDirection: "none", tipo: "dizionario", oggetto: OggettiUtili.Ulss},
           {key: "utenteInserimento", name: "Utente Inserimento", sortDirection: "none"},
           {key: "nome", name: "Nome", sortDirection: "none"},
           {key: "cognome", name: "Cognome", sortDirection: "none"},
           {key: "dataSegnalazione", name: "Data segnalazione", sortDirection: "none", tipo: "data"},
           {key: "scadenza", name: "Tables.Home.scadenza", sortDirection: "none"},
           {
               key: "statoSegnalazione",
               name: "Scheda Standard",
               sortDirection: "none",
               tipo: "pallino",
               oggetto: OggettiUtili.statoSegnalazione
           },
           {
               key: "statoSchedaSpeciale",
               name: "Scheda Speciale",
               sortDirection: "none",
               tipo: "pallino",
               oggetto: OggettiUtili.informazioniTabella
           },
          {
               key: "prosegui", tipo: "link", label: "Prosegui", path: "/wizardSegnalazione",
               nomeParametro: "idSegnalazione"
           }
       ]
   
       constructor(props) {
           super(props);
           this.setStateGenericoSegnalazione = this.setStateGenericoSegnalazione.bind(this)
           this.sendFiltriSegnalazione = this.sendFiltriSegnalazione.bind(this)
   
       }
   
       setStateGenericoSegnalazione(object) {
           this.setState(object)
       }
   
       sendFiltriSegnalazione(filtri) {
           this.props.creaFiltri({filtri: filtri})
       }

    inserisciNuova(row) {
            let path = "/wizardSegnalazione";
    
            SegnalazioniServices.getSingolaSegnalazioneLIS(row.id).then((data) => {
        // Salva i dati necessari nello storage per passarli alla nuova pagina
                history.push({
                    pathname: path,
                   
                    malattia: data.data.infoLaboratorio.codiceSirmi.split('-')[0],
                    nomePaziente: data.data.anagNotificationLis.nome,
                    cognomePaziente: data.data.anagNotificationLis.cognome,
                    codiceFiscale: data.data.anagNotificationLis.cfPaziente,
                    stp: data.data.anagNotificationLis.stp,
                    ulssSegnalazione: data.data.infoLaboratorio.ulss,
                    comuneSegnalazione:data.data.infoLaboratorio.istatComuneLaboratorio,
                    dataSegnalazione:Utils.transformTimeStampForFrontend(data.data.dataSegnalazione),
                    dataDiNascita:Utils.transformTimeStampForFrontend(data.data.anagNotificationLis.dttNascita),
                    sesso:data.data.anagNotificationLis.sesso,
                    comuneResidenza:data.data.anagNotificationLis.cittaResidenza?data.data.anagNotificationLis.cittaResidenza:data.data.anagNotificationLis.paeseResidenza,
                    indirizzoResidenza: data.data.anagNotificationLis.indirizzoResidenza? (data.data.anagNotificationLis.indirizzoResidenza + (data.data.anagNotificationLis.civicoResidenza && true? " " + data.data.anagNotificationLis.civicoResidenza : "")): "",
                    comuneDomicilio:data.data.anagNotificationLis.cittaDomicilio?data.data.anagNotificationLis.cittaDomicilio:data.data.anagNotificationLis.paeseDomicilio,
                    indirizzoDomicilio:data.data.anagNotificationLis.indirizzoDomicilio? (data.data.anagNotificationLis.indirizzoDomicilio + (data.data.anagNotificationLis.civicoDomicilio && true? " " + data.data.anagNotificationLis.civicoDomicilio : "")) : "",
                    formPazienteSpecifico:false,
                    idLisSegnalazione:data.data.id,
                    comuneNascita:data.data.anagNotificationLis.cittaNascita?data.data.anagNotificationLis.cittaNascita:data.data.anagNotificationLis.paeseNascita,
                    infoLaboratorio:'1',
                    tipoLaboratorio:'R',
                    dataEsame:data.data.infoLaboratorio.dttReferto,
                    dataPrelievo:data.data.infoLaboratorio.dttPrelievo,
                    listaDettaglioLab:[data.data.infoLaboratorio.codiceSirmi.split('-')[1]],
                    state: { currentState: states.DATI_SEGNALAZIONE_E_ANAGRAFICI },
                });

                
            }).catch((error) => {
                console.error("Errore durante il recupero della segnalazione:", error);
            });
            sessionStorage.removeItem("parametriRicercaSegnalazioni");
        }

   
       render() {
   
           return (
               <div>
                   <TabelleMonitoraggio
                       cols={this.colsTabMonitoraggio}
                       title={"Stato Segnalazioni"}
                       emptyMsg={"Non ci sono segnalazioni"}
                       lengthEditable={true}
                       homePage={true}
                       information={["01", "07",  "08", "00", "05"]}
                       rowFiltri={this.rowsFiltri}
                       filtri={this.state.filtriSegnalazione}
                       sendFiltri={this.sendFiltriSegnalazione}
                       inserimentoSegnalazioni = {this.inserisciNuova}
                       ruolo={"r"}
                       setStateGenerico={this.setStateGenericoSegnalazione}
                       inserimentoSegnalazioni2 = {"1"}
                   />
               </div>
           )
       }
   
   
   }

export default withTranslation('common')(SegnalazioniDaLIS);

